import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  footer: {
    position: 'fixed',
    bottom: 0,
    left: 48,
    right: 0,
    height: 36,
    padding: 0,
    zIndex: theme.zIndex.drawer + 1,
    borderTopStyle: 'solid',
    borderTopWidth: 1,
    borderTopColor: '#C4C6C9',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('sm')]: {
      left: 0,
    },
  },
  leftContent: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: 16,
  },
  rightContent: {
    marginRight: 16,
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  languagesContainer: {
    marginRight: 16,
  },
  shareContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    width: 160,
    color: '#333333',
    fontSize: 12,
    textTransform: 'uppercase',
    border: 'none',
    background: 'transparent',
    '& + &': {
      marginLeft: 16,
    },
    '&:hover': {
      opacity: 0.9,
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      fontSize: '14',
    },
  },
  selected: {
    color: '#007AFF',
  },
  link: {
    '& + &': {
      marginLeft: 8,
    },
  },
  icon: {
    color: '#9DA5B1',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));
